import { Component, OnInit, Input, Inject, HostBinding } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { PhameeService } from 'src/app/services/phamee.service';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms'
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'smart-plot-experiment',
  templateUrl: './plot-experiment.component.html',
  styleUrls: ['./plot-experiment.component.css','../platform-color/platform-color.css']
})
export class PlotExperimentComponent implements OnInit {

  // Main
  step = 0;
  userrole = sessionStorage.getItem("role");
  @Input() cropId: string;
  @Input() plotId: string;
  @Input() zoneId: string;

  // Page Pagination
  rows = [];
  p: number = 1;
  limit: number = 5;
  total: number;
  new_no: number = 1;

  // Create Demo
  poles = [];
  FormAdddata: any = [];
  FormCreate: FormGroup
  startDate: any;
  startdateReceive: any;
  endDate: any;
  enddateReceive: any;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  // Edit Demo
  editData = [];
  FormEditdata: any = [];
  FormEdit: FormGroup
  dropdownList_edit = [];
  selectedItems_edit = [];

  minDate: any;
  hide_enddate = true;
  hide_select = true;

  poleList: [];
  
  // styles = (sessionStorage.getItem('styles')) ? JSON.parse(sessionStorage.getItem('styles')) : {}
  // @HostBinding('style.--primary-color-bg') get primaryColor() {
  //   return `${this.styles.primary_color_bg}`;
  // }

  constructor(
    private phameeService: PhameeService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private router: Router,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this.FormCreate = this.fb.group({
      no: '',
      name: ['', Validators.required],
      description: '',
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
    });
    this.FormEdit = this.fb.group({
      no_edit: '',
      name_edit: ['', Validators.required],
      description_edit: '',
      start_date_edit: '',
      end_date_edit: '',
    });
  }

  ngOnInit(): void {
    this.getDemonstrates(this.p);
    this.dropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'name',
      selectAllText: 'เลือกทั้งหมด',
      unSelectAllText: 'ยกเลิกทั้งหมด',
      itemsShowLimit: 0,
      allowSearchFilter: true
    };
  }

  dateFormat(date) {
    var datenow = new Date(date);
    // console.log("datenow : ",datenow)
    // moment(lastDate).add(1, 'days').format('YYYY-MM-DD HH:mm:ss')
    return moment(datenow).add(-7, 'hours').format('DD/MM/YYYY');
  }

  getDemonstrates(p: number) {
    this.spinner.show();
    this.phameeService.getDemonstrate(this.cropId, this.limit, p).subscribe(
      result => {
        if (result.code == 200) {
          let data = result.data.data
          console.log("data : ", data)
          for (let i = 0; i < data.length; i++) {
            const element = data[i];
            if (element.poles.length > 20) {
              console.log("OVER 20 CHAR")
              let polelist = element.poles.split(", ")
              console.log("polelist ", polelist)

              Object.assign(element, { poleList: polelist })
            }
          }
          // if(data.poles.length > 20) console.log("OVER 20 CHAR")
          this.rows = data;
          console.log("this.rows  : ", this.rows)
          this.total = result.data.total_rows;
          if (result.data.last_no >= 1) {
            this.new_no = result.data.last_no + 1;
          }
        }
        this.spinner.hide();
      }
    )
  }

  poleSubstring(pole_name) {
    let strLength = pole_name.length;
    // console.log("strLength >>>", name, strLength)
    if (strLength > 20) {
      return pole_name.substring(0, 20) + ".."
    }
    return pole_name
  }

  showFullPolename(polelist) {
    console.log("polelist : ", polelist)
    this.poleList = polelist;
  }
  getPage(pageNo: number) {
    this.p = pageNo;
    this.getDemonstrates(this.p);
  }

  add_experiment() {
    this.step = 1;
  }

  selectstartDate(startdate) {
    console.log("date : ", startdate)
    if (startdate) {
      this.minDate = new Date(startdate);
      this.FormCreate.controls["end_date"].setValue("");
      this.hide_enddate = false;
    } else {
      this.hide_enddate = true;
    }
  }

  getAvailablePole(enddate) {
    var demoEnd = new Date(enddate);
    this.enddateReceive = moment(demoEnd, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format('YYYY-MM-DD');
    this.startdateReceive = moment((<HTMLInputElement>document.getElementById('demo_start_date')).value, 'DD/MM/YYYY', 'Asia/Bangkok').format('YYYY-MM-DD');
    if (this.enddateReceive != "1970-01-01") {
      let poledata = [];
      this.phameeService.getAvailablePole(this.startdateReceive, this.enddateReceive, this.cropId).subscribe(
        poleresult => {
          if (poleresult.code == 200) {
            for (let i = 0; i < poleresult.data.length; i++) {
              poledata.push({
                _id: poleresult.data[i]._id,
                name: poleresult.data[i].name
              });
            }
          }
          this.dropdownList = poledata;
         this.dropdownList.sort(function (a, b) {
            if (b.name.localeCompare(a.name)) { return 1; }
            if (b.name.localeCompare(a.name)) { return -1; }
            return 0;
          });
          this.hide_select = false;
        }
      )
    }
  }

  onItemSelect(item: any) {
    this.selectedItems.forEach(item => {
      if (item != item) {
        this.selectedItems.push(item);
      }
    });
  }

  onDeSelect(unitem: any) {
    this.selectedItems.forEach((item, index) => {
      if (item == unitem) {
        this.selectedItems.splice(index, 1);
      }
    });
  }

  onSelectAll() {
    this.selectedItems = this.dropdownList.map(x => x.name);
  }

  send_adddata_experiment() {
    if (!this.FormCreate.invalid && this.selectedItems.length != 0) {
      this.FormAdddata = {
        crop_id: this.cropId,
        plot_id: this.plotId,
        zone_id: this.zoneId,
        no: this.new_no,
        name: this.FormCreate.value.name,
        desc: this.FormCreate.value.description,
        poles: this.selectedItems,
        start_date: this.startdateReceive,
        end_date: this.enddateReceive,
      }
      this.phameeService.addExperiment(this.FormAdddata).subscribe(
        addresult => {
          if (addresult.code == 200) {
            console.log("success");
            $('#addSuccessmodal').modal('show');
          } else {
            $('#addFailmodal').modal('show');
          }
        }
      )
    } else {
      console.log("failed")
      $('#addFailmodal').modal('show');
    }
  }
  cancel_adddata_experiment() {
    this.FormAdddata = [];
    this.endDate = "";
    this.enddateReceive = "";
    this.startDate = "";
    this.startdateReceive = "";
    this.FormCreate.controls.no.patchValue("");
    this.FormCreate.controls.name.patchValue("");
    this.FormCreate.controls.description.patchValue("");
    this.FormCreate.controls.start_date.patchValue("");
    this.FormCreate.controls.end_date.patchValue("");
    this.poles = [];
    this.selectedItems = [];
    this.step = 0;
  }

  edit_experiment() {
    this.step = 2;
  }

  getExperimentData(demoId) {
    this.spinner.show();
    this.editData = [];
    this.phameeService.getExperimentData(demoId).subscribe(
      demoresult => {
        if (demoresult.code == 200) {
          this.FormEdit.controls["no_edit"].setValue(demoresult.data.no);
          this.FormEdit.controls["name_edit"].setValue(demoresult.data.name);
          this.FormEdit.controls["description_edit"].setValue(demoresult.data.desc);
          // this.FormInflorescenseList.controls["numberOfGoodPodId"].setValue(elements._id);
          this.editData.push({
            _id_: demoresult.data._id,
            no_: demoresult.data.no,
            name_: demoresult.data.name,
            start_date_: demoresult.data.start_date,
            end_date_: demoresult.data.end_date,
            desc_: demoresult.data.desc,
            poles_: demoresult.data.poles,
            avaliable_poles_: demoresult.data.avaliable_poles
          });
        }
        this.selectedItems_edit = this.editData[0].poles_;
        this.dropdownList_edit = this.editData[0].avaliable_poles_;
        this.spinner.hide();
      }
    )
    this.step = 2;
  }

  onItemSelect_edit(item: any) {
    this.selectedItems_edit.forEach(item => {
      if (item != item) {
        this.selectedItems_edit.push(item);
      }
    });
  }

  onDeSelect_edit(unitem: any) {
    this.selectedItems_edit.forEach((item, index) => {
      if (item == unitem) {
        this.selectedItems_edit.splice(index, 1);
      }
    });
  }

  send_editdata_experiment(value) {
    let nameedit: any;
    let descedit: any;
    console.log("this.FormEdit 1 : ", this.FormEdit)
    console.log(" this.selectedItems_edit  : ", this.selectedItems_edit)
    // if (this.FormEdit.value.name_edit == "" || this.FormEdit.value.name_edit == null) {
    //   nameedit = this.editData[0].name_;
    // } else {
    //   nameedit = this.FormEdit.value.name_edit;
    // }

    // if (this.FormEdit.value.description_edit == "" || this.FormEdit.value.description_edit == null) {
    //   descedit = this.editData[0].desc_;;
    // } else {
    //   descedit = this.FormEdit.value.description_edit;
    // }
    if (!this.FormEdit.invalid && this.selectedItems_edit.length != 0) {
      this.FormEditdata = {
        id: this.editData[0]._id_,
        name: this.FormEdit.value.name_edit,
        desc: this.FormEdit.value.description_edit,
        poles: this.selectedItems_edit
      }
      console.log("this.FormEditdata :", this.FormEditdata)
      this.phameeService.editExperiment(this.FormEditdata).subscribe(
        editresult => {
          if (editresult.code == 200) {
            console.log("success");
            $('#editSuccessmodal').modal('show');
          } else {
            $('#EditFailmodal').modal('show');

          }
        }
      )
    } else {
      console.log('ERROR')
      $('#EditFailmodal').modal('show');
    }
  }

  refreshPage() {
    this.step = 0;
    this.ngOnInit();
    this.FormCreate.reset();
    this.FormEdit.reset();
    this.selectedItems = [];
    this.selectedItems_edit = [];
  }


  cancel_editdata_experiment() {
    this.step = 0;
  }

  reload() {
    this.spinner.show();
    setTimeout(() => {
      this.p = 1;
      this.getDemonstrates(this.p);
      this.step = 0;
      this.spinner.hide();
    }, 100);
  }
}
